import { Model } from '@vuex-orm/core'

export default class ShareCandidate extends Model {
  // This is the name used as module name of the Vuex Store.
  static entity = 'shareCandidates'

  static primaryKey = '_id'

  // List of all fields (schema) of the post model. `this.attr` is used
  // for the generic field type. The argument is the default value.
  static fields () {
    return {
      _id: this.attr(null),
      note: this.attr(null),
      candidates: this.attr(null),
      job_id: this.attr(null),
      permissions: this.attr(null),
      expired_at: this.attr(null),
      to: this.attr(null),
      url: this.attr(null),
      author_user_id: this.attr(null),
      account_id: this.attr(null),
      created_at: this.attr(null),
      updated_at: this.attr(null)
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/ShareCandidate.js